import { ISlide } from './i-slide';

export interface ISlideEvent {
  index: number;
  value: ISlide;
}

export class SlideEvent implements ISlideEvent {
  constructor(public index: number, public value: ISlide) {}
}
